"use strict";
import { debounce } from '../utils.js';
import { guests } from '../middleware/guests.js';
import * as XLSX from 'xlsx';

// Fonction pour basculer la confirmation d'un invité
const toggleConfirmation = (guestId, guestsList) => {
  const guest = guestsList.find(g => g.id === guestId);
  if (guest) {
    guest.is_confirmed = !guest.is_confirmed;
    const guestCard = $(`#guest-card-${guest.id}`);
    if (guestCard.length) {
      guestCard.toggleClass('confirmed', guest.is_confirmed);
      guestCard.toggleClass('unconfirmed', !guest.is_confirmed);
      const confirmButton = guestCard.find('.btn-toggle-confirmation');
      confirmButton.text(guest.is_confirmed ? 'Déconfirmer' : 'Confirmer');
      confirmButton.toggleClass('btn-success', !guest.is_confirmed);
      confirmButton.toggleClass('btn-secondary', guest.is_confirmed);
      const guestStatus = guestCard.find('.guest-status');
      guestStatus.text(guest.is_confirmed ? 'Confirmé' : 'Non confirmé');
    }
  }
};

// Fonction pour afficher les détails d'un invité
const showDetails = (guestId, guestsList) => {
  const guest = guestsList.find(g => g.id === guestId);
  if (guest) {
    const specialMention = guest.is_child ? 'Enfant' : guest.is_baby ? 'Bébé' : '';
    let optionsContent = '';
    if (guest.is_child) {
      optionsContent = `${guest.is_menuChild ? 'Menu Enfant, ' : ''}`;
    } else if (guest.is_baby) {
      optionsContent = '';
    } else {
      optionsContent = `
        ${guest.is_vege ? 'Végétarien, ' : ''}
        ${guest.is_notalcool ? 'Sans alcool, ' : ''}
      `;
    }

    alert(`
      Détails de ${guest.name}:
      
      Email: ${guest.email || 'Non renseigné'}
      Statut: ${guest.is_confirmed ? 'Confirmé' : 'Non confirmé'}
      ${specialMention ? `Mention: ${specialMention}` : ''}
      Options: ${optionsContent || 'Aucune option'}
      Commentaires: ${guest.comments || 'Aucun'}
    `);
  }
};

// Fonction pour sauvegarder les modifications d'un invité
const saveGuestChanges = async (guestId, guestsList) => {
  try {
    const guest = guestsList.find(g => g.id === guestId);
    if (guest) {
      const guestCard = $(`#guest-card-${guest.id}`);

      // Mettre à jour les propriétés de l'invité
      guest.is_vege = guestCard.find('.edit-option-vege').is(':checked');
      guest.is_notalcool = guestCard.find('.edit-option-notalcool').is(':checked');
      guest.is_menuChild = guestCard.find('.edit-option-menuChild').is(':checked');
      guest.comments = guestCard.find('.edit-comments').val();

      // Mettre à jour l'affichage de la carte sans recharger toute la liste
      const guestDisplay = guestCard.find(`#guest-display-${guest.id}`);
      const optionsContent = `
        ${guest.is_vege ? 'Végétarien, ' : ''}
        ${guest.is_notalcool ? 'Sans alcool, ' : ''}
        ${guest.is_menuChild ? 'Menu Enfant, ' : ''}
      `.trim().replace(/,\s*$/, ''); // Supprimer la virgule finale

      guestDisplay.find('.guest-display-options').text(optionsContent || 'Aucune option');
      guestDisplay.find('.guest-display-comments').text(guest.comments || 'Aucun');

      // Masquer le formulaire d'édition et afficher les détails
      $(`#guest-edit-${guest.id}`).hide();
      guestDisplay.show();

      // Sauvegarder côté serveur (mock ici avec `guests.editGuestList`)
      const result = await guests.editGuestList([guest]);
      if (result) {
        alert(`Modifications sauvegardées pour ${guest.name}.`);
      } else {
        alert("Erreur lors de la sauvegarde.");
      }
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour :", error);
  }
};

// Fonction pour charger plus d'invités (pagination et recherche)
const loadMoreGuests = (guestsList, searchTerm = '') => {
  const pageSize = 10;
  let filteredGuests = guestsList;

  if (searchTerm) {
    const lowerTerm = searchTerm.toLowerCase();
    filteredGuests = guestsList.filter(guest =>
      guest.name.toLowerCase().includes(lowerTerm) ||
      (guest.email && guest.email.toLowerCase().includes(lowerTerm))
    );
  }

  const invitedby = $('#invitedby').val();
  const isConfirmed = $('#is_confirmed').val();
  const isVege = $('#is_vege').val();
  const isNotalcool = $('#is_notalcool').val();
  const isChild = $('#is_child').val();
  const isBaby = $('#is_baby').val();
  const isMenuChild = $('#is_menuChild').val();
  const tableNumber = $('#table_number').val();

  filteredGuests = filteredGuests.filter(guest => {
    try {
      return (
        (invitedby === '' || guest.invitedby === invitedby) &&
        (isConfirmed === '' || guest.is_confirmed.toString() === isConfirmed) &&
        (isVege === '' || guest.is_vege.toString() === isVege) &&
        (isNotalcool === '' || guest.is_notalcool.toString() === isNotalcool) &&
        (isChild === '' || guest.is_child.toString() === isChild) &&
        (isBaby === '' || guest.is_baby.toString() === isBaby) &&
        (isMenuChild === '' || guest.is_menuChild.toString() === isMenuChild) &&
        (tableNumber === '' || (guest.table_number + "") === tableNumber)
      );
    } catch (error) {
      console.error(" guest " + JSON.stringify(guest) + "  Erreur lors du filtrage : ", error);
      return false;
    }
  });

  const startIndex = (currentPage - 1) * pageSize;
  if (startIndex >= filteredGuests.length) return;
  const endIndex = currentPage * pageSize;

  const countChildren = filteredGuests.filter(guest => guest.is_child === true).length;
  const countMenuChildren = filteredGuests.filter(guest => guest.is_menuChild === true).length;
  const countBabies = filteredGuests.filter(guest => guest.is_baby === true).length;
  const countConfirmed = filteredGuests.filter(guest => guest.is_confirmed === true).length;
  const countVeges = filteredGuests.filter(guest => guest.is_vege === true).length;
  const countNoAlcohol = filteredGuests.filter(guest => guest.is_notalcool === true).length;

  $('#countValue').text(filteredGuests.length);
  $('#countChildren').text(countChildren);
  $('#countBabies').text(countBabies);
  $('#countConfirmed').text(countConfirmed);
  $('#countVeges').text(countVeges);
  $('#countNoAlcohol').text(countNoAlcohol);
  $('#countMenuChildren').text(countMenuChildren);

  // Récupérer la sous-liste à afficher
  const guestsToDisplay = filteredGuests.slice(startIndex, endIndex);

  // Afficher les invités
  renderGuestList(guestsToDisplay, currentPage > 1);

  if (guestsToDisplay.length > 0) {
    currentPage++;
  }
};

// Fonction pour rendre la liste des invités
const renderGuestList = (filteredGuests, append = false) => {
  if (!append) {
    $('#guestListContainer').empty();
  }

  filteredGuests.forEach(guest => {
    const specialMention = guest.is_child
      ? `<span class="badge bg-secondary" style="font-family:'Fjalla One', sans-serif; font-size:12px; font-weight:400;">Enfant</span>`
      : guest.is_baby
        ? `<span class="badge bg-secondary" style="font-family:'Fjalla One', sans-serif; font-size:12px;font-weight:400;">Bébé</span>`
        : '';

    let optionsContent = guest.is_child
      ? `${guest.is_menuChild ? 'Menu Enfant, ' : ''}`
      : guest.is_baby
        ? ''
        : `
          ${guest.is_vege ? 'Végétarien, ' : ''}
          ${guest.is_notalcool ? 'Sans alcool, ' : ''}
        `;

    const guestCard = `
      <div class="col-md-6">
        <div id="guest-card-${guest.id}" class="guest-card ${guest.is_confirmed ? 'confirmed' : 'unconfirmed'}">
          <h3>${guest.name} ${specialMention ? ' - ' + specialMention : ''}</h3>
          <p><strong>Email:</strong> ${guest.email || 'Non renseigné'}</p>
          <p><strong>Statut:</strong> <span class="guest-status">${guest.is_confirmed ? 'Confirmé' : 'Non confirmé'}</span></p>
          <div id="guest-display-${guest.id}">
            <p><strong>Options:</strong> <span class="guest-display-options">${optionsContent || 'Aucune option'}</span></p>
            <p><strong>Commentaires:</strong> <span class="guest-display-comments">${guest.comments || 'Aucun'}</span></p>
            <button data-guest-id="${guest.id}" class="btn btn-edit-guest btn-sm btn-warning">Modifier les options</button>
          </div>
          <div id="guest-edit-${guest.id}" class="guest-edit-form" style="display: none;">
            <button data-guest-id="${guest.id}" class="mb-3 btn btn-toggle-confirmation btn-sm ${guest.is_confirmed ? 'btn-secondary' : 'btn-success'}">
              ${guest.is_confirmed ? 'Déconfirmer' : 'Confirmer'}
            </button><br/>
            <label><input type="checkbox" class="edit-option-vege" ${guest.is_vege ? 'checked' : ''}> Végétarien</label><br>
            <label><input type="checkbox" class="edit-option-notalcool" ${guest.is_notalcool ? 'checked' : ''}> Sans alcool</label><br>
            ${guest.is_child ? `<label><input type="checkbox" class="edit-option-menuChild" ${guest.is_menuChild ? 'checked' : ''}> Menu Enfant</label>` : ''}
            <p><strong>Commentaires:</strong></p>
            <textarea class="edit-comments form-control">${guest.comments || ''}</textarea>
            <button data-guest-id="${guest.id}" class="btn btn-save-guest btn-sm btn-primary mt-2">Enregistrer</button>
            <button data-guest-id="${guest.id}" class="btn btn-cancel-edit btn-sm btn-secondary mt-2">Annuler</button>
          </div>
        </div>
      </div>
    `;

    $('#guestListContainer').append(guestCard);
  });
};

// Initialisation du tableau de bord
let currentPage = 1;

export async function initDashboadGuestsListEvents(admin) {
  const zeAdmin = admin || JSON.parse(localStorage.getItem('admin'));

  $('#adminName').text(zeAdmin.name);
  $('#adminRole').text(zeAdmin.role);
  const guestsList = await guests.getGuests() || [];

  // Charger la première page d'invités
  loadMoreGuests(guestsList);

  // Événements
  $(document).on('click', '.btn-toggle-confirmation', function () {
    const guestId = $(this).data('guest-id');
    toggleConfirmation(guestId, guestsList);
  });

  $(document).on('click', '.btn-edit-guest', function () {
    const guestId = $(this).data('guest-id');
    $(`#guest-display-${guestId}`).hide();
    $(`#guest-edit-${guestId}`).show();
  });

  $(document).on('click', '.btn-cancel-edit', function () {
    const guestId = $(this).data('guest-id');
    $(`#guest-edit-${guestId}`).hide();
    $(`#guest-display-${guestId}`).show();
  });

  $(document).on('click', '.btn-save-guest', function () {
    const guestId = $(this).data('guest-id');
    saveGuestChanges(guestId, guestsList);
  });

  $('#export-guests-excel-btn').on('click', function () {
    const ws = XLSX.utils.json_to_sheet(guestsList);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Invités");
    XLSX.writeFile(wb, 'guests_list.xlsx');
  });

  // Recherche
  $('#searchInput').on('input', debounce(function () {
    const searchTerm = $(this).val().trim();
    currentPage = 1;
    loadMoreGuests(guestsList, searchTerm);
  }, 300));

  $(document).on('change', '#filters select', function () {
    currentPage = 1;
    const searchTerm = $('#searchInput').val().trim();
    loadMoreGuests(guestsList, searchTerm);
  });

  // Défilement infini
  $(window).on('scroll', function () {
    const $searchInput = $('#searchInput');
    if ($searchInput.length) {
      const searchTerm = $searchInput.val().trim();
      if (searchTerm === '' && $(window).scrollTop() + $(window).height() >= $(document).height() - 100) {
        loadMoreGuests(guestsList);
      }
    } else {
      console.log('L\'élément #searchInput est introuvable.');
    }
  });
}
